import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'summary-reports'
const verb = 'get'

const DATA_OVERLOAD_ERROR = 'Date range is too large. Please select a shorter date range to run your report.'

export default class OspreyGetSummaryReports extends BaseAction {
    constructor(dataKey, onError) {
        const id = '737283ea-88db-8e83-f336-f8bd6072f5a6'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true

        this.onError = onError

        this.errorMap = {
            '504': DATA_OVERLOAD_ERROR
        }
    }

    /**
     * @param {object} params
     * @param {string} [params.date]
     * @param {string} [params.token]
     * @param {string} programId
     * @param {string} ownerOrn
     * @returns {function(): Promise}
     */
    getSummaryReports(params) {
        const { date, token, programId, ownerOrn } = params

        this.path = `/${resource}/${programId}/summaries`
        this.params = {
            date,
            token,
            ownerOrn
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/summary-reports/get-summary-reports.js